'use strict';

var SiteSelectorPromptDialogController = function($scope, $rootScope, AnnotationStore) {

  var vm = this;

  vm.showDialog = false;

  $scope.$on('dialog:siteSelector:promptDiscardActiveAnnotation', function() {
    vm.showDialog = true;
  });

  vm.closeModal = function() {
    vm.showDialog = false;
  };

  vm.perform = function() {
    vm.closeModal();
    $rootScope.$broadcast('dialog:siteSelector:confirmDiscardActiveAnnotation');
  };

};

SiteSelectorPromptDialogController.$inject = ['$scope', '$rootScope', 'AnnotationStore'];
module.exports = SiteSelectorPromptDialogController;


// WEBPACK FOOTER //
// ./src/app/dash/siteSelector/dialog/SiteSelectorPromptDialogController.js